import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from './index.styl';

const ValidationError = ({ content, style, className }) => (
  <div styleName="error" {...{ className, style }}>
    {content}
  </div>
);

ValidationError.propTypes = {
  content: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CSSModules(ValidationError, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/ValidationError/index.jsx